import React from 'react';
import { ListingCard } from './ListingCard';
import { Skeleton } from '../ui/skeleton';

export const ListingGrid = ({ 
  listings, 
  loading = false, 
  savedListings = [], 
  onSave,
  emptyMessage = 'No listings found',
  columns = 4 
}) => {
  if (loading) {
    return (
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-${columns} gap-6`}>
        {[...Array(8)].map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="aspect-[4/3] w-full rounded-md" />
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-8 w-1/2" />
            <div className="flex gap-4">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-4 w-20" />
            </div>
            <Skeleton className="h-4 w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  if (!listings || listings.length === 0) {
    return (
      <div className="text-center py-16" data-testid="empty-listings">
        <div className="text-muted-foreground text-lg">{emptyMessage}</div>
      </div>
    );
  }

  const gridCols = {
    2: 'lg:grid-cols-2',
    3: 'lg:grid-cols-3',
    4: 'lg:grid-cols-3 xl:grid-cols-4',
  };

  return (
    <div 
      className={`grid grid-cols-1 md:grid-cols-2 ${gridCols[columns] || gridCols[4]} gap-6`}
      data-testid="listings-grid"
    >
      {listings.map((listing, index) => (
        <div 
          key={listing.id} 
          className="animate-fade-in"
          style={{ animationDelay: `${index * 0.05}s` }}
        >
          <ListingCard
            listing={listing}
            isSaved={savedListings.includes(listing.id)}
            onSave={onSave}
          />
        </div>
      ))}
    </div>
  );
};

export default ListingGrid;
